
@if (autoTermResponse) {
  <div class="mb-3 message-card red">
        <mwp-text-translate text="You are currently enrolled in the option below. You may not be enrolled in more than one option for this category.
        The option below will be terminated when the alternative plan is confirmed. Click CONFIRM to continue." jsonKey="autoBenefitAutoTermResponse" />
    </div>
  }
  @if (autoEnrollResponse) {
    <div class="mb-3 message-card green">
        <mwp-text-translate text="The benefit you have selected includes additional benefits. These benefits are pre-selected
        and are required under the terms of this benefit. If you are currently enrolled in any of the
        benefits listed below, these benefits will remain active." jsonKey="autoBenefitAutoEnrollResponse" />
      </div>
    }
    <div class="content-container mb-3">
      <div class="content">
        <mwp-table [tableColumns]="autoColumns" [dataSource]="autoBenefits" />
      </div>
      <div class="footer">
        <mwp-benefit-enrollment-wizard-control (emitComplete)="continueWizard()" />
      </div>
    </div>
    